import { FC } from "react";
import { Modal, Text, Group, Button } from "@mantine/core";
import { useStyles } from "../Regtank.styles";
import { BUTTON_STYLES, BUTTON_LABELS } from "../Regtank.constants";

interface ConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  message: string;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}

/**
 * Reusable confirmation modal for approve/reject actions
 * Consolidates duplicate modal code
 */
export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  opened,
  onClose,
  title,
  message,
  onConfirm,
  confirmLabel = BUTTON_LABELS.confirm,
  cancelLabel = BUTTON_LABELS.cancel,
}) => {
  const { classes } = useStyles();

  return (
    <Modal
      classNames={{
        title: classes.modalTitle,
      }}
      title={title}
      opened={opened}
      onClose={onClose}
      size="md"
      centered
    >
      <div>
        <Text className={classes.subSmallText}>{message}</Text>
      </div>
      <div>
        <Group mt="xl" position="center">
          <Button onClick={onClose} style={BUTTON_STYLES.cancel}>
            {cancelLabel}
          </Button>
          <Button onClick={onConfirm} style={BUTTON_STYLES.confirm}>
            {confirmLabel}
          </Button>
        </Group>
      </div>
    </Modal>
  );
};